import { useMediaQuery, useTheme } from "@mui/material";

export default function useIsWidescreen() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up("lg"));
}
